import React from 'react';
var CardComponent = function CardComponent(_ref) {
  var cardBodyClassName = _ref.cardBodyClassName,
    className = _ref.className,
    children = _ref.children,
    withHeader = _ref.withHeader,
    headerText = _ref.headerText,
    headerClass = _ref.headerClass,
    withFooter = _ref.withFooter,
    footerText = _ref.footerText;
  return /*#__PURE__*/React.createElement("div", {
    className: "card ".concat(className)
  }, withHeader && /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-0 card-title ".concat(headerClass)
  }, headerText)), /*#__PURE__*/React.createElement("div", {
    className: "card-body ".concat(cardBodyClassName)
  }, children), withFooter && /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, footerText));
};
CardComponent.defaultProps = {
  withHeader: false,
  headerText: undefined,
  withFooter: false,
  footerText: undefined,
  className: "py-3 px-3",
  cardBodyClassName: undefined,
  headerClass: ''
};
export default CardComponent;